import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: String,
    duration: { type: Number, default: 3000 }
  }

  notify() {
    window.dispatchEvent(
      new CustomEvent("notify", {
        detail: {
          message: this.messageValue,
          duration: this.durationValue
        },
        bubbles: true
      })
    )
  }
}
